import { NumericFormat } from "react-number-format";
import { getConfig } from "../../../config";
import { COMPANY_CODE, PN_STATIC_CATEGORY_SALARY_FOR_DRIVER, PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME } from "../../../utils/Utils";

const { company } = getConfig();

export const colTableNvvp = () => ([
  {
    Header: "Nhân viên",
    accessor: (item, index) => `${index + 1} - ${item.user?.name}`,
  },
  {
    Header: "Lương cơ bản(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.baseSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Trách nhiệm(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.responsibilityAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thâm niên(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.annualSalary}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương đóng BHXH",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.salaryForInsurance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Ăn(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.foodAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Xăng xe(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.travelAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Tuân thủ(VS/ATLD)(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.laborSafetyAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Điện thoại(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.telephoneAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Nhà ở(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.housingSubsidy}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thưởng năng suất(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.productivitySalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thưởng khác(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.anotherBonus || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trừ nghỉ BHXH(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.insuranceLeaveFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương hoạch toán(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.grossSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "Đóng BHXH(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.insuranceFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  ...(company === COMPANY_CODE.CT ? [{
    Header: "Phí Công Đoàn(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.unionFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  }] : []),
  {
    Header: "Thu nhập chịu thuế(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.taxableIncome || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Người phụ thuộc",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.dependents || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Tổng giảm trừ(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.pitDeduction || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thu nhập tính thuế(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.assessableIncome || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "TNCN(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.pit || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trừ khác(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.anotherFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "Thực lãnh(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.finalSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
])


export const colTableCn = () => ([
  {
    Header: "Nhân viên",
    accessor: (item, index) => `${index + 1} - ${item.user?.name}`,
  },
  {
    Header: "Lương cơ bản(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.baseSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Ngày công",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.workingDay || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Ngày nghỉ",
    className: 'text-right',
    accessor: (item) => <>
      <NumericFormat
        displayType={"text"}
        value={item.leaveDay || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
      <span className="ml-1">(P:{item.annualLeave}, KL: {item.unpaidLeave}, KP:{item.unauthorizedLeave}, B:{item.sickLeave}, KV:{item.emptyTaskLeave})</span>

    </>,
  },
  {
    Header: "Ngày phép còn lại",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.lessAnnualLeave || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Giờ tăng ca(h)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.extraAndBonusHour || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "NV xuất sắc(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.bestEmployeeAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trách nhiệm(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.responsibilityAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thâm niên(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.annualSalary}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương chức vụ(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.positionSalary}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trợ cấp độc hại(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.toxicAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương đóng BHXH(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.salaryForInsurance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: " Lương CB tính lương(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.salaryForCalculator || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương ngày công(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.workingSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương nghỉ phép(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.leaveSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương nghỉ không có việc(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.emptyTaskLeaveSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Chuyên cần(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.attendanceAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Nấu dầu(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.oilAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Ăn(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.foodAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Xăng xe(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.travelAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Tuân thủ(VS/ATLD)(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.laborSafetyAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Điện thoại(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.telephoneAllowance}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Nhà ở(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.housingSubsidy}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thưởng năng suất(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.productivitySalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương tăng ca(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.extraAndBonusSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "TC tiền ăn tăng ca(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.extraHourFoodAllowance || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "Thưởng khác(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.anotherBonus || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trừ nghỉ BHXH(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.insuranceLeaveFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương hạch toán(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.grossSalary}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Đóng BHXH(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.insuranceFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  ...(company === COMPANY_CODE.CT ? [{
    Header: "Phí Công Đoàn(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.unionFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  }] : []),
  {
    Header: "Thu nhập chịu thuế(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.taxableIncome}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "Người phụ thuộc",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.dependents || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Tổng giảm trừ(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.pitDeduction || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Thu nhập tính thuế(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.assessableIncome || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "TNCN(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.pit || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Trừ khác(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.anotherFee || 0) * -1}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },

  {
    Header: "Thực nhận(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.finalSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
]);


export const colTableDriver = [
  {
    Header: "Ngày nghỉ",
    accessor: (item) => item.leaveDay || 0,
  },
  {
    Header: "Lương cơ bản(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.baseSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Trợ cấp(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={(item.foodAllowance || 0) + (item.travelAllowance || 0) + (item.housingSubsidy || 0)}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Chi phí cá nhân(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.personalCost || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Lương chuyến(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.driverBonus || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  {
    Header: "Tổng thu nhập(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.grossSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  },
  ...(Object.values(PN_STATIC_CATEGORY_SALARY_FOR_DRIVER).map((ingredientId) => ({
    Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[ingredientId]}(đ)`,
    className: 'text-right',
    accessor: (item) => (
      <NumericFormat
        displayType={"text"}
        value={(item?.personalInDetail?.[ingredientId] || 0) * -1}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}

      />
    ),
  }))),
  {
    Header: "Thực nhận(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.netSalary || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />,
  }
];